import { dateTimeNoSeconds } from '../../shared/dateTime';

/**
 * „W tym stanie od” w szczegółach zlecenia — kiedy i kto.
 *
 * Pusty stempel to brak zapisu, nie data do odgadnięcia (decyzja z #274:
 * historii wstecz nie dopisujemy). Stempel stawia każda zmiana stanu od
 * 28.09.2026 — operator i import; nie ma go w rekordach, których stan
 * zmieniono wcześniej, i w zleceniach utworzonych importem, które stanu
 * jeszcze nie zmieniły. Mówimy więc, czego nie wiemy, zamiast pokazywać
 * datę utworzenia albo gołą kreskę bez wyjaśnienia (e2e 28.09.2026).
 */
export const STATUS_SINCE_UNKNOWN =
  'brak zapisu (stan nadany przy imporcie z TMS albo przed 28.09.2026)';

export function statusSinceText(
  since: unknown,
  by: { username?: string | null } | null | undefined,
): string {
  if (typeof since !== 'string' || since === '') return STATUS_SINCE_UNKNOWN;
  const who = by?.username ? ` — ${by.username}` : '';
  return `${dateTimeNoSeconds(since)}${who}`;
}
